
import { useThemeMode } from "@/hooks/useThemeMode";

export interface EnhancedThemeConfig {
  glassMorphism: boolean;
  neumorphism: boolean;
  animations: boolean;
  glowEffects: boolean;
}

export const useEnhancedTheme = (): EnhancedThemeConfig => {
  return {
    glassMorphism: true,
    neumorphism: false,
    animations: true,
    glowEffects: true,
  };
};

export const getGlassMorphismClasses = (enabled: boolean, isDark: boolean): string => {
  if (!enabled) return "";
  
  // Sharp glass effect without backdrop blur
  return isDark 
    ? "bg-slate-900/90 border-slate-400/80 shadow-xl shadow-slate-500/20"
    : "bg-white/95 border-slate-500/80 shadow-xl shadow-slate-400/20";
};

export const getNeumorphismClasses = (enabled: boolean, isDark: boolean): string => {
  if (!enabled) return "";
  
  return isDark
    ? "shadow-[inset_0_2px_4px_rgba(0,0,0,0.6),inset_0_-2px_4px_rgba(255,255,255,0.1)] border-slate-600/50"
    : "shadow-[inset_0_2px_4px_rgba(0,0,0,0.1),inset_0_-2px_4px_rgba(255,255,255,0.8)] border-slate-300/50";
};

export const getSharpGlowEffect = (color: string, intensity: "light" | "medium" | "heavy"): string => {
  const intensities = {
    light: "0 0 10px",
    medium: "0 0 20px",
    heavy: "0 0 30px",
  };
  
  return `${intensities[intensity]} ${color}`;
};

export const getAnimationVariants = () => {
  return {
    fadeIn: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 0.3 }
    },
    slideUp: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.3 }
    }
  };
};

// Re-export everything from the enhanced theme system
export * from './useEnhancedTheme/context';
export * from './useEnhancedTheme/styleUtils';
export * from './useEnhancedTheme/aiPersonalization';
export * from './useEnhancedTheme/types';
